module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "popup-wapper",
    class: [_vm.showModel ? 'show-in' : 'hide-out']
  }, [_c('div', {
    staticClass: "popup-bg"
  }), _vm._v(" "), _vm._t("popup-cont")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-093e4278","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/zui/Popup.vue
// module id = 809
// module chunks = 0